import { Fill, Stroke, Style } from 'ol/style.js';

const SIGNAL_STYLES = {
  red: new Style({
    stroke: new Stroke({ color: 'rgba(220,38,38,0.9)', width: 1.5 }),
    fill: new Fill({ color: 'rgba(220,38,38,0.3)' }),
    zIndex: 3,
  }),
  orange: new Style({
    stroke: new Stroke({ color: 'rgba(234,88,12,0.9)', width: 1.5 }),
    fill: new Fill({ color: 'rgba(234,88,12,0.22)' }),
    zIndex: 2,
  }),
  yellow: new Style({
    stroke: new Stroke({ color: 'rgba(202,138,4,0.9)', width: 1.5 }),
    fill: new Fill({ color: 'rgba(202,138,4,0.18)' }),
    zIndex: 1,
  }),
};

export function protectionAreaStyleFunction(feature) {
  const signal = feature.get('signal');
  return SIGNAL_STYLES[signal] ?? SIGNAL_STYLES.yellow;
}
